import styled from 'styled-components';
import PhoneNumber from './PhoneNumber';
import Selector from 'components/Selector';
import { InputContainer } from 'components/Input/Input.styled';
import { InputLabel as OriginalInputLabel } from 'components/Input/Input.styled';

export const PhoneInputContainer = styled(InputContainer)`
  display: flex;
  justify-content: space-between;
`;

export const PhoneCountryCodeSelector = styled(Selector)`
  width: 98px;
  height: 48px;
  margin-right: 8px;
  padding: 8px 16px;
`;

export const PhoneNumberInput = styled(PhoneNumber)`
  width: 198px;
`;

export const InputLabel = styled(OriginalInputLabel)`
  margin-bottom: 8px; ;
`;
